import React, { Component,Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-bootstrap';
import * as WorkOrderActionType from '../../Work-Orders/constants';
import * as TradeActionType from 'Trades/constants';
import * as ItemActionType from 'Items/constants';
import * as SubcontractorActionType from 'Subcontractors/constants';
import * as LotActionType from 'Lots/constants';
import * as PurchaseOrderActionType from '../../Purchase-Orders/constants';
import * as PunchListActionType from '../constants';
import RFSInfo from '../../Work-Orders/Components/RFSInfo';
import WorkOrderFiles from '../../Work-Orders/Containers/work-order-file';
import WorkOrderComments from '../../Work-Orders/Components/WorkOrderComments';
import WorkOrderInformation from '../../Work-Orders/Containers/work-order-information';
import { print } from '../../helper/unit-helper';
import { AppSettings } from '../../constants';
import PurchasesOrdersList from '../../Purchase-Orders/Components/PurchaseOrdersList';
import Translate from 'components/translate';
import { EmailButton } from '../../Work-Orders/Components/EmailButton';
import EmailPopup from '../../Work-Orders/Components/EmailPopup';
import queryString from 'query-string';
class WorkOrderDetail extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    PunchListItemProfile: PropTypes.object,
    ManagerStore: PropTypes.object,
    TradeList: PropTypes.any,
    ItemRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
    itemRepairList: PropTypes.any,
    SubcontractorList: PropTypes.any,
    LotList: PropTypes.any,
    WorkOrderCommentList: PropTypes.any,
    ManagePurchaseOrders: PropTypes.any,
    PunchListProfile: PropTypes.object,
    LotProfile: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      punchListRefNo: props.match.params.punchListRefNo,
      punchListItemRefNo: props.match.params.punchListItemRefNo,
      formValue: {},
      requireFormField: [],
      showEmailInputBox:false,

      popup: {
        isShowOpenPopup: false,
        isShowPendPopup: false,
        isShowResolvePopup: false,
        isShowSignoffPopup: false,
        isShowDeclinePopup: false,
        isShowOpenPendingPopup: false,
        isShowReopenPopup: false,
      },
      queryParams: { page: 1, size: 10, sort: 'descending' },
    };

    this.onTogglePopup = this.onTogglePopup.bind(this);
  }

  componentDidMount() {
    // if (!this.props.PunchListItemProfile) {
    this.fetchPunchItemDetail();
    // }
    this.fetchWorkOrderComments({ ...this.state.queryParams });
    this.fetchPOList({
      sortField: 'refNo',
      sortOrder: 'descending',
      WoRefNo: this.state.punchListItemRefNo,
    });
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: PunchListActionType.RESET_PUNCH_LIST_ITEM,
    });

    this.props.dispatch({
      type: WorkOrderActionType.RESET_WORK_ORDER_PROFILE,
    });
  }

  fetchPOList = (data = {}) => {
    if (AppSettings.clientTypeValue === 'Subcontractor') {
      this.props.dispatch({
        type: PurchaseOrderActionType.GET_SUBCONTRACTOR_PURCHASE_ORDER_LIST_ASYNC,
        params: {
          WOID: this.state.punchListItemRefNo,
          data,
        },
      });
    } else {
      this.props.dispatch({
        type: PurchaseOrderActionType.GET_PURCHASE_ORDER_LIST_ASYNC,
        params: {
          WOID: this.state.punchListItemRefNo,
          data,
        },
      });
    }
  };

  fetchPunchItemDetail = () => {
    this.props.dispatch({
      type: PunchListActionType.GET_PUNCH_LIST_ITEM_DETAIL_ASYNC,
      params: {
        punchListRefNo: this.state.punchListRefNo,
        punchListItemRefNo: this.state.punchListItemRefNo,
      },
      callback:()=>{
        setTimeout(() => {
          this.props.dispatch({
            type: WorkOrderActionType.GET_LAST_RESOLVED_WORK_ORDER,
            params: {
              WOID:this.state.punchListItemRefNo,
            },
        })
        }, 1000);
      }
    });
  };

  fetchTrade = () => {
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.PunchListItemProfile.requestDetail
          ? this.props.PunchListItemProfile.requestDetail.lot.id
          : this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false,
      },
    });
  };

  fetchItemRepair = (tradeId) => {
    this.props.dispatch({
      type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
      params: {
        id: tradeId,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false,
      },
    });
  };

  fetchProblem = (itemToRepairId) => {
    this.props.dispatch({
      type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
      params: {
        id: itemToRepairId,
        searchKey: '',
      },
    });
  };

  fetchSubcontractor = (tradeId) => {
    this.props.dispatch({
      type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
      params: {
        projectId: this.props.PunchListItemProfile.project.id,
        lotId: this.props.PunchListItemProfile.lot.id,
        tradeId: tradeId,
        param: {
          searchKey: '',
          selectedValue: '',
        },
      },
    });
  };

  fetchWorkOrderComments = (queryParams) => {
    const params = {
      take: queryParams.size,
      skip: queryParams.page - 1,
    };
    this.props.dispatch({
      type: WorkOrderActionType.GET_WORK_ORDER_COMMENTS_ASYNC,
      params: {
        workOrderId: this.state.punchListItemRefNo,
        rfsId: this.state.punchListRefNo,
        data: params,
      },
    });
  };

  onClickAddComment = (comment, commentAction) => {
    let data = { comment };

    if (commentAction) {
      data['commentAction'] = commentAction;
    }

    this.props.dispatch({
      type: WorkOrderActionType.ADD_WORK_ORDER_COMMENTS_ASYNC,
      params: {
        workOrderId: this.state.punchListItemRefNo,
        rfsId: this.state.punchListRefNo,
        data,
      },
      callback: () => {
        // if (currentPage === 1) {
        this.fetchWorkOrderComments(this.state.queryParams);
        // }
      },
    });
  };

  onClickEditButton = (e) => {
    e.preventDefault();
    this.props.history.push(
      `/work-order/edit/${this.state.punchListRefNo}/${this.state.punchListItemRefNo}`
    );
  };

  onClickSubmitPopup = (e) => {
    e.preventDefault();
  };

  onClickSubmitOpenPend = (type, params) => {
    if (type === 'open') {
      this.props.dispatch({
        type: WorkOrderActionType.OPEN_AN_AWAITING_WORK_ORDER_ASYNC,
        params: {
          refNo: this.state.punchListItemRefNo,
          data: params,
        },
      });
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.PEND_WORK_ORDER_ASYNC,
        params: {
          refNo: this.state.punchListItemRefNo,
          data: params,
        },
      });
    }

    this.onClickCancelPopup();
  };

  onClickCancelPopup = () => {
    this.setState({ popup: {} });
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
    });
    if (name === 'itemRepair') {
      this.setState({
        problem: null,
      });
    }
    if (name === 'trade') {
      this.setState({
        subcontractor: null,
        itemRepair: null,
        problem: null,
      });
    }
  };

  onTogglePopup = (type) => () => {
    const { woInformation } = this.props.PunchListItemProfile.workOrder;
    const requireFormField = [];
    if (!woInformation.trade) {
      requireFormField.push('trade');
    }
    if (!woInformation.subcontractorProfile) {
      requireFormField.push('subcontractor');
    }
    if (!woInformation.itemToRepair) {
      requireFormField.push('itemRepair');
    }
    if (!woInformation.problem) {
      requireFormField.push('problem');
    }

    if (!requireFormField.length && type === 'open') {
      let params = {
        tradeId: woInformation.trade.id,
        itemToRepairId: woInformation.itemToRepair.id,
        subcontractorId: woInformation.subcontractorProfile.subcontractorId,
        workOrderTypeId: woInformation.workOrderType.id,
        problemId: woInformation.problem.id,
        status: 'Open',
      };
      this.onClickSubmitOpenPend(type, params);
    } else if (
      requireFormField.length === 1 &&
      requireFormField.includes('subcontractor') &&
      type === 'pend'
    ) {
      let params = {
        tradeId: woInformation.trade.id,
        itemToRepairId: woInformation.itemToRepair.id,
        subcontractorId: null,
        workOrderTypeId: woInformation.workOrderType.id,
        problemId: woInformation.problem.id,
        status: 'Pending',
      };
      this.onClickSubmitOpenPend(type, params);
    } else {
      switch (type) {
        case 'open': {
          this.setState({
            popup: {
              isShowOpenPopup: !this.state.popup.isShowOpenPopup,
            },
            requireFormField,
          });
          break;
        }
        case 'pend':
          this.setState({
            popup: {
              isShowPendPopup: !this.state.popup.isShowPendPopup,
            },
            requireFormField,
          });
          break;
        default:
          break;
      }
    }
  };

  onToggleResolvePopup = () => {
    this.setState({
      popup: {
        isShowResolvePopup: !this.state.popup.isShowResolvePopup,
      },
    });
  };

  onToggleSignoffPopup = () => {
    this.setState({
      popup: {
        isShowSignoffPopup: !this.state.popup.isShowSignoffPopup,
      },
    });
  };

  onToggleDeclinePopup = () => {
    this.setState({
      popup: {
        isShowDeclinePopup: !this.state.popup.isShowDeclinePopup,
      },
    });
  };

  onSaveResolvePopup = (lastResolvedDate) => {
    this.props.dispatch({
      type: WorkOrderActionType.RESOLVE_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.punchListItemRefNo,
        data: {
          status: 'Resolved',
          lastResolvedDate: lastResolvedDate,
        },
      },
    });
    this.onToggleResolvePopup();
  };

  onSaveSignoffPopup = (lastResolvedDate, lastClosedDate) => {
    this.props.dispatch({
      type: WorkOrderActionType.SIGN_OFF_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.punchListItemRefNo,
        data: {
          status: 'Closed',
          lastResolvedDate: lastResolvedDate,
          lastClosedDate: lastClosedDate,
        },
      },
    });
    this.onToggleSignoffPopup();
  };

  onSaveDeclinePopup = (declineReason) => {
    this.props.dispatch({
      type: WorkOrderActionType.DECLINE_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.punchListItemRefNo,
        data: {
          status: 'Declined',
          declinedReason: declineReason,
        },
      },
    });
    this.onToggleDeclinePopup();
  };

  onSaveOpenPendingPopup = (data) => {
    this.props.dispatch({
      type: WorkOrderActionType.OPEN_PENDING_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.punchListItemRefNo,
        data: {
          status: 'Open',
          subcontractorId: data,
        },
      },
    });
    this.onToggleOpenPendingPopup();
  };

  onToggleOpenPendingPopup = () => {
    const { woInformation } = this.props.PunchListItemProfile.workOrder;
    if (
      woInformation.subcontractorProfile &&
      woInformation.subcontractorProfile.subcontractorId
    ) {
      this.onSaveOpenPendingPopup(
        woInformation.subcontractorProfile.subcontractorId
      );
    } else {
      this.setState({
        popup: {
          isShowOpenPendingPopup: !this.state.popup.isShowOpenPendingPopup,
        },
      });
    }
  };

  onToggleReopenPopup = () => {
    this.setState({
      popup: {
        isShowReopenPopup: !this.state.popup.isShowReopenPopup,
      },
    });
  };

  onSaveReopenPopup = (isFromResolved, reopenReason) => {
    this.props.dispatch({
      type: WorkOrderActionType.RE_OPEN_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.punchListItemRefNo,
        isFromResolved: isFromResolved,
        data: {
          status: 'Reopen',
          reopenReason: reopenReason,
        },
      },
    });
    this.onToggleReopenPopup();
  };

  onReviewReopenWorkOrder = (type) => {
    this.props.dispatch({
      type: WorkOrderActionType.REVIEW_RE_OPEN_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.punchListItemRefNo,
        data: {
          status: type,
        },
      },
    });
  };

  printPreviewWorkOrder = () => {
    const {
      PunchListItemProfile: { builderProfile },
    } = this.props;
    if (AppSettings.clientTypeValue === 'Subcontractor') {
      this.props.dispatch({
        type: WorkOrderActionType.PRINT_PREVIEW_SUBCONTRACTOR_WORK_ORDER_ASYNC,
        params: {
          endpoint: builderProfile.printWOEndpoint,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken,
          },
        },
        callback: (status, content) => {
          if (status) {
            print(content);
          }
        },
      });
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.PRINT_PREVIEW_WORK_ORDER_ASYNC,
        params: {
          refNo: this.state.punchListItemRefNo,
        },
        callback: (status, content) => {
          if (status) {
            print(content);
          }
        },
      });
    }
  };
  onClickOnEmailButton = () => {
    this.setState({ showEmailInputBox: true});
  }

 onCloseEmailBox = () => {
    this.setState({ showEmailInputBox: false });
  }
  objToParams = obj => {
    const urlParams = queryString.parse(this.props.location.search);
    
    if (AppSettings.clientTypeValue === 'Builder') {
      return {
        searchKey:
          typeof urlParams.searchKey !== 'undefined'
            && urlParams.searchKey,
        skip: obj.skip || 0,
        Recipients: obj.recipients || [],
        TimeZoneOffset: -(new Date()).getTimezoneOffset(),
        Refno:this.state.punchListItemRefNo
      };
    }
    return {
      searchKey: typeof urlParams.searchKey !== 'undefined'
      && urlParams.searchKey,
      skip: obj.skip || 0,
      Recipients: obj.recipients || [],
      TimeZoneOffset: -(new Date()).getTimezoneOffset(),
      Refno:this.state.punchListItemRefNo
    };
  };
  toolTip(type) {
    return (
      <Tooltip className='in tooltip-siteone'>
        {type === 'open' && (
          <span>
            Opening a work order will also send it to the specified
            subcontractor.
          </span>
        )}
        {type === 'pend' && (
          <span>
            Pending a work order will not send it to the specified subcontractor
            (if any)
          </span>
        )}
      </Tooltip>
    );
  }

  renderRequestHomeOwner() {
    // const { RFSProfile } = this.state;

    return (
      <div className='form-group'>
        <div className='col-sm-12'>
          <span className='text-danger'>
            This request is generated by <Translate translateKey='homeowner' />
          </span>
        </div>
      </div>
    );
  }

  renderBreadcrumb() {
    return (
      <div>
        <div className='page-title clearfix'>
          <div>
            <h2 className='pull-left'>WO #{this.state.punchListItemRefNo}</h2>
          </div>
          <div>
            <div className='text-right'>
            <Fragment>

            <EmailButton onClick={this.onClickOnEmailButton} overlay={false} toolTipText="Send WO in Email" style={{color:'#333333', paddingRight:30}}/>
            {
            this.state.showEmailInputBox && <EmailPopup
            objToParams={this.objToParams}
            onClose={this.onCloseEmailBox}
            initRecipientEmails={this.state.recipientEmail}
            workOrder = {'WO detail'}
            />
            }
            <i
            onClick={this.printPreviewWorkOrder}
            className='glyphicon glyphicon-print print-icon'
            />
            </Fragment>
            </div>
          </div>
        </div>
        <ul className='breadcrumb'>
          <li>
            <Link to={'/punch-lists'}>
              {AppSettings.clientTypeValue === 'Builder'
                ? 'Blue Tape'
                : // <Translate translateKey='punchlist' plurals capitalize />
                  ' Punch lists'}
            </Link>
          </li>
          <li>
            <Link to={`/punch-lists/${this.state.punchListRefNo}`}>
              {AppSettings.clientTypeValue === 'Builder' ? 'BT #' : 'PL #'}
              {this.state.punchListRefNo}
            </Link>
          </li>
          <li className='breadcrumb-siteone-li'>
            WO #{this.state.punchListItemRefNo}
          </li>
        </ul>
      </div>
    );
  }

  renderWorkOrderFile() {
    // if (AppSettings.clientTypeValue === 'Subcontractor') {
    //   if (this.props.PunchListItemProfile && this.props.PunchListItemProfile.workOrder.woInformation && this.props.PunchListItemProfile.workOrder.woInformation.status === 1) {
    //     return <WorkOrderFiles punchListItemRefNo={this.state.punchListItemRefNo} />;
    //   }
    //   return null;
    // }
    return (
      <WorkOrderFiles
        history={this.props.history}
        workOrderId={this.state.punchListItemRefNo}
        readOnly={
          AppSettings.clientTypeValue === 'Subcontractor' ? true : false
        }
      />
    );
  }

  render() {
    const { LotProfile } = this.props;
    if (
      this.props.PunchListItemProfile &&
      this.props.PunchListItemProfile.workOrder &&
      this.props.PunchListItemProfile.workOrder.woInformation
    ) {
      return (
        <div className='rfs-detail add-new-work-order'>
          {this.renderBreadcrumb()}
          <div className='wrapper'>
            {/*{this.props.ManagerStore.RFSProfile && this.props.ManagerStore.RFSProfile.project &&
            <RFSInfo RFSInformation={this.props.ManagerStore.RFSProfile} />
          }*/}
            {this.props.PunchListItemProfile &&
              this.props.PunchListItemProfile.requestDetail && (
                <RFSInfo
                  RFSInformation={
                    this.props.PunchListProfile &&
                    this.props.PunchListProfile.project
                      ? this.props.PunchListProfile
                      : this.props.PunchListItemProfile.requestDetail
                  }
                  location={this.props.location}
                  history={this.props.history}
                  mode='punchList'
                  displayNote={true}
                  LotProfile={LotProfile}
                />
              )}

            {this.props.PunchListItemProfile &&
              this.props.PunchListItemProfile.workOrder &&
              this.props.PunchListItemProfile.workOrder.woInformation && (
                <WorkOrderInformation
                  location={this.props.location}
                  history={this.props.history}
                  workOrderProfile={this.props.PunchListItemProfile}
                  rfsInformation={
                    this.props.ManagerStore.RFSProfile &&
                    this.props.ManagerStore.RFSProfile.project
                      ? this.props.ManagerStore.RFSProfile
                      : this.props.PunchListItemProfile.requestDetail
                  }
                  rfsId={this.state.punchListRefNo}
                  workOrderId={this.state.punchListItemRefNo}
                  addComment={this.onClickAddComment}
                  isPunchItem={true}
                  comments={this.props.WorkOrderCommentList}
                />
              )}
            {this.renderWorkOrderFile()}
            {AppSettings.clientTypeValue !== 'Homeowner' &&
              AppSettings.clientTypeValue !== 'Subcontractor' && (
                <PurchasesOrdersList
                  ManagePurchaseOrders={this.props.ManagePurchaseOrders}
                  WorkOrderProfile={this.props.PunchListItemProfile}
                  rfsId={this.state.punchListRefNo}
                  workOrderId={this.state.punchListItemRefNo}
                  fetchPOList={this.fetchPOList}
                  isPunchList={true}
                />
              )}
            <WorkOrderComments
              comments={this.props.WorkOrderCommentList}
              addComment={this.onClickAddComment}
              fetchWorkOrderComments={this.fetchWorkOrderComments}
              WorkOrderProfile={this.props.PunchListItemProfile}
              hidePrivateNotes={true}
            />
          </div>
          <iframe
            id='ifmcontentstoprint'
            style={{ height: 0, border: 'none' }}
          />
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    ManagerStore: state.RFSStore,
    PunchListItemProfile: state.PunchListStore.PunchListItemProfile,
    PunchListProfile: state.PunchListStore.PunchListProfile,
    LotList: state.ProjectStore.LotList,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    TradeList: state.LotStore.TradeList,
    ItemRepairList: state.TradeStore.ItemRepairList,
    ProblemList: state.ItemRepairStore.ProblemList,
    WorkOrderCommentList: state.WorkOrderReducer.WorkOrderCommentList,
    ManagePurchaseOrders: state.PurchaseOrderStore.ManagePurchaseOrder,
    LotProfile: state.LotStore.LotProfile,
  };
};

export default connect(mapStateToProps)(WorkOrderDetail);



// WEBPACK FOOTER //
// ./src/Punch-List/Containers/punch-list-item-detail.js